@if (customerEndpointAddressSelected()) {
<div class="report-container">
  @if (_fetchingApiData) {
  <div class="main-view-container-loader">
    <img [src]="'assets/icons/loading.svg'">
    <div style="margin-left: 8px;">Loading...</div>
  </div>
  } @else {
  <div class="left-content">
    <p class="preview-title">Page Preview</p>
    @if (summaryPage() && summaryPage().dateRange) {
    <div class="preview-pdf-container" (click)="handlePreviewPress(-1, 'summary')"
      [ngClass]="{'selected': selectedIndex() === -1}">
      <report-layout class="mini-preview first-item">
        <summary-report [summaryDataObj]="summaryPage()" [chartData]="chartData"></summary-report>
      </report-layout>
    </div>
    }

    <p class="preview-item-title">Summary Page</p>

    @if (interactionPages() && interactionPages().length > 0) {
    @for (interaction of interactionPages(); track interaction.ConversationId; let i = $index) {
    <div class="preview-pdf-container" (click)="handlePreviewPress(i)" [ngClass]="{'selected': selectedIndex() === i}">
      <report-layout class="mini-preview">
        <interaction-report [interactionData]="interaction" [index]="i+1"></interaction-report>
      </report-layout>
    </div>
    <p class="preview-item-title">Interaction {{i+1}} Summary</p>
    }
    }
  </div>

  <div class="right-content-wrapper">

    @if (!hideInfoBox && !hideInfoBoxForever()) {
    <div class="msg-container">
      <div class="msg-row">
        <div class="msg-left-content">
          <img class="info-icon" src="assets/icons/info.svg" alt="info-icon">

          Apply relevant filters from the filter menu and select a customer endpoint address to refine your data.
        </div>
        <img class="close-icon" src="assets/icons/close_msg.svg" alt="close-icon" (click)="handleInfoClosePress()">

      </div>
      <div class="chk-box-row">
        <div class="chk-box-container" (click)="handleCheckBoxPress()" [ngClass]="{'checked': _hideInfoBoxForever} ">
          @if (_hideInfoBoxForever) {
          <img class="done-icon" src="assets/icons/done.svg" alt="done-icon">
          }
        </div>
        Don't show this message again
      </div>
    </div>
    }

    <div class="pdf-actions-row">
      <div class="file-name-wrapper">
        <div class="file-name" [ngClass]="{'active': inputFocused, 'error': inputName.length > 50} ">
          <input class="report-input" type="text" [ngModel]="inputName" #inputNameRef="ngModel"
            (focus)="inputFocused = true" (blur)="inputFocused = false" name="inputName" (input)="checkValue($event)" />
          <button class="save-btn" [disabled]="disabled" [ngClass]="{'disabled': disabled}"
            (click)="handleSavePress()">Save</button>
        </div>
        <div *ngIf="inputName.length > 50" class="error-text">
          Maximum 50 Characters
        </div>
      </div>
      <button class="download-btn" (click)="capturePages()">
        <p>Download</p>
        <img src="assets/icons/file_download_1.svg" alt="download-icon">
      </button>
    </div>

    <div class="right-content" #rightContent>

      @if (summaryPage() && summaryPage().dateRange) {
      <div class="report-layout-wrapper">
        <div class="report-layout-container" id="summaryPage">
          <report-layout>
            <summary-report [summaryDataObj]="summaryPage()" [chartData]="chartData"></summary-report>
          </report-layout>
        </div>
      </div>
      }

      @if (interactionPages() && interactionPages().length > 0) {
      @for (interaction of interactionPages(); track interaction.ConversationId; let i = $index) {
      <div class="report-layout-wrapper">
        <div class="report-layout-container" id="page{{i}}">
          <report-layout>
            <interaction-report [interactionData]="interaction" [index]="i+1"></interaction-report>
          </report-layout>
        </div>
      </div>
      }
      }
    </div>
  </div>
  }


  @if(pdfLoading){
  <div class="overlay-loader">
    <img class="loading-icon" src="assets/icons/loader.svg" alt="loader-icon">
    <div class="loading-text">Pdf generating</div>
  </div>
  }

</div>
} @else {
<div class="no-customer-selected">
  <div class="empty-text">No <span class="highlight">Customer Endpoint Address</span> selected!
    <div>Please choose an endpoint from the filters to preview PDF.</div>
  </div>
  <div class="choose-button" (click)="handleChooseFilterPress()">
    Choose Filter
    <mat-icon class="arrow-up">arrow_upward</mat-icon>
  </div>
</div>
}